export default "__VITE_ASSET__D9RHHuU7__"